import * as api from "./client";

export type GlobalSearchSectionKey =
  | "companies"
  | "contacts"
  | "lawyerProfiles"
  | "articles"
  | "teamPages"
  | "organisations"
  | "staffUsers"
  | "practiceAreas"
  | "regions"
  | "cmsPages";

export type GlobalSearchItem = {
  id: string;
  title: string;
  subtitle?: string;
};

export type GlobalSearchSection = {
  key: GlobalSearchSectionKey;
  label: string;
  items: GlobalSearchItem[];
};

export type GlobalSearchError = {
  key: string;
  message: string;
};

export type GlobalSearchResponse = {
  query: string;
  sections: GlobalSearchSection[];
  errors: GlobalSearchError[];
};

export const globalSearchService = {
  /**
   * Staff-wide search across entity types (staff-bff `GET /v1/search`).
   * The BFF hides empty sections and filters them by the caller's permissions.
   */
  search(query: string, signal: AbortSignal): Promise<GlobalSearchResponse> {
    const params = new URLSearchParams({ q: query });
    return api.getWithSignal<GlobalSearchResponse>(`/v1/search?${params.toString()}`, signal);
  },
};
